/**
 * Google Map
 * @description :
 */

export default function (rootEl) {
    if (!window.google || !window.google.maps) {
        console.warn('Google Maps library was not found.');
        document.querySelector('.js-google-map').style.outline = '1px solid red';
        return;
    }

    const dataScriptEl = rootEl.querySelector('.js-google-map-data');
    const infoWindowTemplateEl = rootEl.querySelector('.js-google-map-info-window-template');
    const embedEl = rootEl.querySelector('.js-google-map-embed');
    const pinMarker = rootEl.querySelector('.js-google-map-pin-marker');

    const infoWindowTemplate = infoWindowTemplateEl ? infoWindowTemplateEl.textContent.trim() : '{pinTitle}';

    const data = JSON.parse(dataScriptEl.textContent);
    if (!data || !data.locations) {
        console.warn('Google map had no locations configured.');
        document.querySelector('.js-google-map').style.outline = '1px solid red';
        return;
    }

    const zoomLevel = data.zoomLevel;
    const isDesktop = window.matchMedia(`(min-width: ${window.breakpoints.desktop}px)`).matches;

    const googleMapsOptions = {
        mapTypeControl: isDesktop,
        zoom: zoomLevel,
        streetViewControl: false
    };

    const map = new google.maps.Map(embedEl, googleMapsOptions);

    const icon = {
        url: pinMarker.textContent,
        scaledSize: isDesktop ? new google.maps.Size(50, 50) : new google.maps.Size(30, 30)
    };

    const bounds = new google.maps.LatLngBounds();

    data.locations.forEach(location => {
        const marker = new google.maps.Marker({
            position: { lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) },
            map,
            title: location.pinTitle,
            icon: icon
        });

        bounds.extend(marker.position);

        if (location.pinTitle) {
            let infoWindowContent = infoWindowTemplate;
            for (const propertyName in location) {
                infoWindowContent = infoWindowContent.replaceAll(`{${propertyName}}`, location[propertyName] || '');
            }

            const infoWindow = new google.maps.InfoWindow({
                content: infoWindowContent,
            });

            marker.addListener("click", () => {
                infoWindow.open({
                    anchor: marker,
                    map,
                    pixelOffset: 4,
                    shouldFocus: true,
                });
            });
        }

    });

    const idleListener = google.maps.event.addListener(map, 'idle', () => {
        if (map.getZoom() > zoomLevel) {
            map.setZoom(zoomLevel);
        }
        google.maps.event.removeListener(idleListener);
    });

    map.fitBounds(bounds);

};
